export const environment = {
  production: true,
  buildId: '2649583053218201',
  configFile: 'config.json',
};
